import React from 'react';
import { Navigate } from 'react-router-dom';
import { appRoutes } from '../path';
import toastMessage from '../utils/toastMessage';
import LayoutOutlet from '../Layout/LayoutOutlet';
import useOptionalDefaultSchemaId from './Formulas/utils/useOptionalDefaultSchemaId';
import { isNil } from 'lodash';

/**
 * A wrapper for routes that are schema-dependent. If user tries to enter such
 * route without default schema ID - redirect to data modeler page
 */
const SchemaRequiredRoute = () => {
  const schemaId = useOptionalDefaultSchemaId();
  if (isNil(schemaId)) {
    toastMessage({
      message: `No active Schemas found. Please create or enable at least one schema`,
      type: 'error',
    });

    return <Navigate to={appRoutes.modeler.routePrefix} replace={true} />;
  }

  return <LayoutOutlet />;
};

export default SchemaRequiredRoute;
